import React from 'react'
import { Markdown } from '../shared/typography'
import {
  Card,
  Divider,
  HeadingUppercase,
  StackView,
} from '@planningcenter/tapestry-react'

export default class PermissionsNotes extends React.Component {
  render() {
    return (
      <Card spacing={<Divider />} marginBottom={2}>
        <Card.Section tag="header" subdued>
          <HeadingUppercase>Notes:</HeadingUppercase>
        </Card.Section>
        <Card.Section>
          <StackView shrink={1}>
            <Markdown>{this.props.source}</Markdown>
          </StackView>
        </Card.Section>
      </Card>
    )
  }
}
